<template>
	<div class="page-question">
    <img src="../../static/images/indexNq-share.jpg" style="display:none;">
		<transition name="fade">
		<!-- 题目图片 -->
		<div class="question-pic">
			<img v-bind:src="question.image">
		</div>
		</transition>
		<!-- 题目图片 -->
		<!-- 题目选项 -->
		<ul class="question-cont" >
			<h1>{{ question.question_title }}</h1>
			<li	v-for="( item, i ) in question.options"
					@click="answerQuestion(item.option)">
					<p>{{ optionIndex[i] }}.&nbsp;{{ item.title }}</p>
			</li>
		</ul>
		<!-- 题目选项 -->
		<!-- 题目跳转 -->
		<div class="question-nav">
			<a v-show="(curQuestion > 1) & !submit" @click="toPrevQuestion()" class="prevQues"></a>
			<a v-show="((curQuestion) == questionListLength) & !submit" @click="submitAnswers()" class="submitQues"></a>
			<a v-show="((curQuestion) == questionListLength) & submit" class="submitWait">提交中</a>
		</div>
		<!-- 题目跳转 -->
		<!-- 题目进度 -->
		<div class="question-progress">
			<div class="progress-bg">
				<i v-bind:style="{ width: (curQuestion/questionListLength)*100 + '%'}"></i>
			</div>
			<div class="progress-text">
				{{ curQuestion }}/{{ questionListLength }}
			</div>
		</div>
		<!-- 题目进度 -->
		<!-- 壹心理Logo -->
		<yxl-logo></yxl-logo>
		<!-- 壹心理Logo -->
		<!-- 做过题目的弹窗 -->
		<div v-if="finishTest" class="hasDone">
      <div class="mask">!</div>
      <div class="dialog">
        <h1>WARNNING</h1>
        <p>您已完成本次测试，请勿重复提交。</p>
        <div class="actions">
          <a href="javascript:;" class="btn" @click="toFunreport()">朕知道了</a>
        </div>
      </div>
		</div>
		<!-- 做过题目的弹窗 -->
	</div>
</template>
<script>
import { mapState } from 'vuex'
import { mapMutations } from 'vuex'
import { mapActions } from 'vuex'
import logo from '../components/yxl-logo.vue'
import qrcodeMask from '../components/qrcodeMask.vue'

import router from '../router.js'

export default {
	name: 'QuestionPage',
	components: {
		yxlLogo: logo,
		qrcodeMask: qrcodeMask
	},
	data() {
		return {
			isFirstShare: true,
			qrCodeMask: false,
			submit: false
		}
	},
	created() {
		if( this.isOwnEmpty(this.$store.state.questions) ) {
			// 题目为空，回去首页
			router.push({
	      name:'index',
	      path: '/index'
	    });
		} else {
			router.push({
        name:'question',
        params:{
          questionId: this.$store.state.curQuestion
        }
      });
		}
		if(this.$route.query.channel_id) {
      this.setChannelId(this.$route.query.channel_id)
    }
    if(this.GetQueryString("channel_id")) {
      this.setChannelId(this.GetQueryString("channel_id"));
    }
	},
	mounted() {
		document.title = '你是萌兽，还是猛兽？';
		// 微信分享
		var that = this;
		wx.ready(function() {
			console.log(that);
			wx.onMenuShareAppMessage({
				title: '你是萌兽，还是猛兽？', // 分享标题
				desc: '超准的心理测试，用动物看出你真正的性格！',
				link: "http://static.xinli001.com/animalPicture/index.html", // 分享链接
				imgUrl: "http://static.xinli001.com/animalPicture/static/images/indexNq-share.jpg", // 分享图标
				type: '', // 分享类型,music、video或link，不填默认为link
				dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
				success: function () {
          zhuge.track('测评活动', {
              '被分享页面' : '首页或答题页',
          });
				},
				cancel: function () {
				  // 用户取消分享后执行的回调函数
				}
			});


      wx.onMenuShareTimeline({
        title: '你是萌兽，还是猛兽？', // 分享标题
        link: 'http://static.xinli001.com/animalPicture/index.html', // 分享链接
        imgUrl: "http://static.xinli001.com/animalPicture/static/images/indexNq-share.jpg", // 分享图标
        success: function () {
          zhuge.track('测评活动', {
              '被分享页面' : '首页或答题页',
          });
        },
        cancel: function () {
            // 用户取消分享后执行的回调函数
        }
      });

			wx.hideMenuItems({
		    menuList: [
					'menuItem:share:qq',
					'menuItem:share:weiboApp',
					'menuItem:share:QZone',
					"menuItem:openWithSafari",
		    ] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
			});
		})

	},
	beforeUpdate() {
		if(this.$store.state.questions[this.$store.state.curQuestion].selected == undefined) {
			this.$store.state.questions[this.$store.state.curQuestion].selected = '';
		}
		let pArray = document.querySelectorAll('.question-cont p');
		for(var i = 0; i < pArray.length; i ++) {
			pArray[i].className = ''
		}
		this.curAnswer = this.$store.state.answers[this.curQuestion.question_id];
	},
	computed: {
		curAnswer (){
			 let state = this.$store.state;
			 return state.answers[this.question.question_id] == undefined?'':state.answers[this.question.question_id];
		},
		...mapState({
			curQuestion: state => state.curQuestion,
			question: state => state.questions[state.curQuestion],
			optionIndex() {
				return ['A','B','C','D'];
			},
			questionListLength: state => state.questionListLength,
			answers: state => state.answers,
			selfResult: state => state.selfResult,
			finishTest: state => state.finishTest,
			channel_id: state => state.channel_id
		})
	},
	methods: {
		...mapActions([
      'pullQuestion',
      'createFunReport'
    ]),
		...mapMutations ([
	    'setCurQuestion',
	    'setAnswers',
	    'setBusy',
	    'setChannelId'
	  ]),
		answerQuestion(selectedOption) {
			let pArray = document.querySelectorAll('.question-cont p');
			for(var i = 0; i < pArray.length; i ++) {
				pArray[i].className = ""
			}
			event.target.className += 'selected';
			if(this.curQuestion <= this.questionListLength){
				this.setAnswers({
					key: this.question.question_id,
					value: selectedOption
				});

				this.answers[this.question.question_id] = selectedOption;
				this.$data.curAnswer = selectedOption;
				if(this.curQuestion < this.questionListLength) {
					// 还不是最后一题
					this.toNextQuestion()
				}
			}
		},
		toNextQuestion() {
			var that = this;
			if(that.$store.state.answers[that.question.question_id+""] != ''){
				if(that.$store.state.busy) {
					console.log('busy!!!!');
					return ;
				}
				that.setBusy(true);
				setTimeout(function() {
					that.setCurQuestion(that.$store.state.curQuestion+1);
					that.setBusy(false);
					router.push({
		        name:'question',
		        params:{
		          questionId: that.$store.state.curQuestion
		        }
		      });
				}, 500);
			}
		},
		toPrevQuestion() {
			if((this.curQuestion-1)>=0){
				this.setCurQuestion(this.curQuestion-1);
				router.push({
	        name:'question',
	        params:{
	          questionId: this.curQuestion
	        }
	      });
			}
		},
		submitAnswers() {
			let that = this;
			let params = {
				gender: this.$store.state.sex,
				params: this.$store.state.answers,
			};
			// if(free_test_id) {
			// 	params.free_test_id = free_test_id;
			// }
			// if(from_user_id) {
			// 	params.from_user_id = from_user_id;
			// }
			if(!this.$data.submit) {
				let that = this;
				this.createFunReport({
					dataPack: params,
					callback: function(){
						router.push({
							name: 'funreport',
							path: '/funreport',
			        query: {
			          channel_id: that.channel_id
			        }
						});
					},
					check: that.getObjLength,
					questionListLength: that.questionListLength
				});
				that.$data.submit = true;
				setTimeout(function () {
					that.$data.submit = false;
				}, 5000)
			} else {
				console.log('busy')
			}
		},
		toFunreport() {
			router.push({
				name: 'funreport',
				path: '/funreport'
			})
		}
	}
}
</script>

<style scoped lang="scss">

$font-size-base:32; // Base on 320rem * 0.5;
@function topx($rem) {
  @return $rem/$font-size-base;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-active {
  opacity: .5;
}
.page-question {
  overflow: hidden;
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('../../static/images/all_bg.png');
	min-height: 100vh;
	.question-pic {
		position: relative;
		margin-top: topx(35rem * 0.5);
		margin-left: auto;
		margin-right: auto;
		width: topx(245rem * 0.5);
		height: topx(215rem * 0.5);
		background: url('../../static/images/question-image.png');
		background-size: topx(245rem * 0.5) topx(215rem * 0.5);
		img {
			position: absolute;
			top: topx(15rem * 0.5);
			left: topx(25rem * 0.5);
			width: topx(190rem * 0.5);
			height: topx(190rem * 0.5);
			border-radius: 50%;
		}
	}

	.question-cont {
		margin: topx(45rem * 0.5) topx(45rem * 0.5) 0 topx(45rem * 0.5);
		h1 {
			margin: 0 0 topx(25rem * 0.5) 0;
			font-size: topx(28rem * 0.5)!important;
			line-height: topx(48rem * 0.5);
			color: #252323;
		}
		li {
			margin-bottom: topx(15rem * 0.5);
			display: block;
			font-size: topx(24rem * 0.5)!important;
			p {
				padding: topx(0rem * 0.5) topx(20rem * 0.5) topx(0rem * 0.5) topx(7rem * 0.5);
				margin: 0;
				font-size: topx(24rem * 0.5)!important;
				line-height: topx(48rem * 0.5);
				&.selected {
					background: #ccc;
				}
			}
		}
	}

	.question-nav {
		margin-top: topx(60rem * 0.5);
		min-height: topx(76rem * 0.5);
		text-align: center;
		font-size: 0;
		a {
			display: inline-block;
			width: topx(134rem * 0.5);
			height: topx(70rem * 0.5);
		}
		.prevQues {
			background: url('../../static/images/question-prev.png') no-repeat;
			background-size: topx(134rem * 0.5) topx(68rem * 0.5);
		}
		.submitQues {
			margin-left: topx(120rem * 0.5);
			background: url('../../static/images/question-submit.png') no-repeat;
			background-size: topx(133rem * 0.5) topx(68rem * 0.5);
		}
		.submitWait {
			width: topx(133rem * 0.5);
			height: topx(68rem * 0.5);
			box-sizing: border-box;
			margin-left: 0;
			display: inline-block;
			padding: 0 topx(23rem * 0.5);
			line-height: topx(67rem * 0.5);
			background: rgb(250, 202, 105);
			border: topx(4rem * 0.5) solid rgb(246, 183, 29);
			border-radius: topx(15rem * 0.5);
			font-size: topx(26rem * 0.5);
			color: rgb(168, 122, 27);
		}
	}

	.question-progress {
		margin: topx(45rem * 0.5) auto topx(100rem * 0.5) auto;
		width: topx(539rem * 0.5);
		.progress-bg {
			width: topx(540rem * 0.5);
			height: topx(20rem * 0.5);
			background: url('../../static/images/question-progress.png');
			background-size: topx(539rem * 0.5) topx(19rem * 0.5);

			i {
				display: block;
				height: topx(19rem * 0.5);
				background: #d49f12;
			}
		}
		.progress-text {
			text-align: right;
			font-size: topx(18rem * 0.5);
		}
	}

	.hasDone {
    .mask {
      position: fixed;
      z-index: 99;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: #000;
      opacity: .75;
    }
    .dialog {
      width: topx(437rem * 0.5);
      position: fixed;
      z-index: 99;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      border-radius: topx(30rem * 0.5);
      overflow: hidden;
      h1 {
        margin: topx(20rem * 0.5) topx(70rem * 0.5) 0 topx(70rem * 0.5);
        color: #000000;
        font-size: topx(30rem * 0.5);
        line-height: topx(40rem * 0.5);
        text-align: center;
      }
      p {
        margin: topx(16rem * 0.5) topx(70rem * 0.5) 0 topx(70rem * 0.5);
        color: #000000;
        font-size: topx(24rem * 0.5);
        line-height: topx(42rem * 0.5);
        text-align: left;
      }
      .actions {
        margin-top: topx(25rem * 0.5);
        text-align: center;
        font-size: 0;
        border-top: topx(1rem * 0.5) solid #e4af22;
        a {
          display: inline-block;
          box-sizing: border-box;
          width: 100%;
          height: topx(67rem * 0.5);
          line-height: topx(67rem * 0.5);
          font-size: topx(24rem * 0.5);
          color: #876a19;
          background: #edcb6f;
          border-left: topx(1rem * 0.5) solid #e4af22;
          &:first-child {
            border-left: topx(0rem * 0.5) solid #e4af22;
          }
        }
      }
    }
	}
}
</style>



// WEBPACK FOOTER //
// question.vue?7f2cd43a